var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_body",class:{ 'mobile-style': _vm.$isMobileDevice }},[_c('div',{staticClass:"common_title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"common_content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }